import { stringify, parse } from 'query-string';

/*
  Overriding order:
  parent querystring > iframe querystring > iframe hash > local storage > form default params
  Note that quotation params (age/gender/smoker) are not overriden by the params here.
 */
export const getAllQueryParams = () => {
  let params = {};

  let isIframeAndCanAccessParent = false;

  const { hash } = window.location;
  if (hash) {
    params = {
      ...params,
      ...parse(hash),
    };
  }

  // use params from the page itself anyway, no matter it is iframe or not
  const iframeSearchString = window.location.search;
  if (iframeSearchString) {
    params = {
      ...params,
      ...parse(iframeSearchString),
    };
  }

  // if the page is in an iframe, try to use params from the parent if possible
  try {
    isIframeAndCanAccessParent =
      window.parent &&
      window.location !== window.parent.location &&
      window.parent.location.search;
  } catch {
    /* eslint-disable spaced-comment */
    //failed to get parent, probably due to CORS
  }

  if (isIframeAndCanAccessParent) {
    const parentSearchString = window.parent.location.search;
    if (parentSearchString) {
      params = {
        ...params,
        ...parse(parentSearchString),
      };
    }
  }

  return params;
};

export const buildSearchString = paramsList => {
  let res = {};
  paramsList.forEach(params => {
    res = { ...res, ...params };
  });
  return stringify(res);
};

export const buildSearchStringWithAllQueryParams = policyParams => {
  return buildSearchString([policyParams, getAllQueryParams()]);
};

export const buildUrl = (url, policyParams) => {
  const [urlWithoutHash, hash = ''] = url.split('#');
  return `${`${urlWithoutHash}?${buildSearchString([
    policyParams,
    getAllQueryParams(),
  ])}`}#${hash}`;
};
